import { Box, Card, Text } from '@ksyos/design-system';

type InvoicingNotContractedCareProps = {
    insurerName?: string | null;
};

export function InvoicingContractedCare(props: Readonly<InvoicingNotContractedCareProps>) {
    const { insurerName } = props;

    return (
        <>
            <Card>
                <Card.Body>
                    <Box maxWidth={620}>
                        {`Volgens onze gegevens ben jij verzekerd bij ${insurerName}. Ksyos heeft een contract met deze zorgverzekeraar.
                    Lees hieronder wat jij moet doen.`}
                    </Box>
                </Card.Body>
            </Card>
            <Card>
                <Card.Body>
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={6}
                        maxWidth={620}
                    >
                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="factuur"
                                src="/assets/images/somnology/insurance/Factuur_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>
                                Ksyos stuurt de rekening(en) direct naar je zorgverzekeraar. Hierin staan de kosten voor
                                de zorg die je hebt ontvangen.
                            </Text>
                        </Box>

                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="vergoeding"
                                src="/assets/images/somnology/insurance/Vergoeding_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>Jouw zorgverzekeraar betaalt het hele bedrag aan Ksyos.</Text>
                        </Box>

                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="row"
                            gap={6}
                        >
                            <img
                                alt="patient-betaalt"
                                src="/assets/images/somnology/insurance/Betalen_MK.svg"
                                style={{ width: '67px' }}
                            />
                            <Text>
                                Als jij nog eigen risico hebt openstaan dit jaar, betaal jij dit aan jouw
                                zorgverzekeraar.
                            </Text>
                        </Box>
                    </Box>
                </Card.Body>
            </Card>
        </>
    );
}
